module.exports = __webpack_public_path__ + "static/media/everyday_digital_weekend_papers_may_2024.8bd87b05.png";